import { createStore } from 'vuex'
import menu from './modules/menu'
import layout from './modules/layout'
import language from './modules/language'
import auth from './modules/auth'
import homeSections from './modules/homeSections'
import pedidos from './modules/pedidos'

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    menu,
    layout,
    language,
    auth,
    homeSections,
    pedidos,
  },
})
